import { useEditor, useNode } from "@craftjs/core";
import * as React from "react";

import { useOnClickOutside } from "@/hooks/use-on-click-outside";
import useViewportContext from "@/hooks/use-viewport-context";
import togglePageScrollLock from "@/utils/toggle-page-scroll-lock";

import HamburgerButton from "./hamburger-button-component";
import { StyledNavigationList } from "./navigation-list-component-styles";

export const NavigationList = (props: {
  isCentered: boolean;
  menu: React.ReactNode;
}) => {
  const { node } = useNode((node) => ({
    node,
  }));

  const { enabled, actions } = useEditor((state) => {
    return {
      enabled: state.options.enabled,
    };
  });

  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const navWrapperRef = React.useRef<HTMLDivElement | null>(null);
  const { viewport } = useViewportContext();
  const isMobile = viewport === "mobile";

  React.useEffect(() => {
    setIsMenuOpen(false);
    togglePageScrollLock({ method: "remove", withOffset: true });
  }, [viewport]);

  const toggleMenu = () => {
    if (isMenuOpen) {
      node.dom.classList.remove("block-on-top");

      if (node.props.isSticky) {
        node.dom.classList.add("block-sticky");
      }

      setIsMenuOpen(false);
      togglePageScrollLock({ method: "remove", withOffset: true });
    } else if (!isMenuOpen && !enabled) {
      node.dom.classList.add("block-on-top");

      if (node.props.isSticky) {
        node.dom.classList.remove("block-sticky");
      }

      setIsMenuOpen(true);

      togglePageScrollLock({ method: "add", withOffset: true });
    }
  };

  const closeMobileNavOnItemClick = ({ target }) => {
    const isClickedNavItem = target?.classList.contains("button-primitive");

    if (isMobile && !enabled && isClickedNavItem) {
      toggleMenu();
    }
  };

  const disableEditOptions = ({ target }) => {
    const isClickedNavItem = target?.classList.contains("button-primitive");

    if (isMobile && enabled && isClickedNavItem) {
      actions.selectNode(node.id);
    }
  };

  useOnClickOutside(navWrapperRef, () => (enabled ? toggleMenu() : null), {
    isActive: isMenuOpen,
  });

  return (
    <div ref={navWrapperRef} className="navigation-list-wrapper">
      <HamburgerButton
        disabled={enabled}
        isMenuOpen={isMenuOpen}
        toggleMenu={toggleMenu}
      />
      <StyledNavigationList
        data-testid="navigation-list"
        className="navigation-list"
        isMenuOpen={isMenuOpen}
        isCentered={props.isCentered}
        onClick={closeMobileNavOnItemClick}
        onMouseDown={disableEditOptions}
      >
        {props.menu}
      </StyledNavigationList>
    </div>
  );
};
